/**
 * apiErrorMessage — bir axios/DRF hatasından kullanıcıya gösterilecek net
 * mesajı çıkarır.
 *
 * DRF iki farklı hata şekli döndürür:
 *   1. APIException        → { detail: "..." }
 *   2. ValidationError     → { starts_at: ["Geçmiş bir tarih..."], ... }
 *                            veya { non_field_errors: ["..."] }
 *
 * Önceki kod yalnızca `data.detail`'a bakıyordu; field-bazlı validation
 * hataları (örn. geçmiş tarih) `.detail` içermediği için generic "Hata"ya
 * düşüyordu. Bu helper üç şekli de ele alır ve ilk anlamlı mesajı döndürür.
 */
export function apiErrorMessage(e: any, fallback = "Bir hata oluştu"): string {
  const data = e?.response?.data;

  // Ağ/timeout gibi response'suz hatalar
  if (data == null) {
    return e?.message || fallback;
  }

  // Düz string body
  if (typeof data === "string") {
    return data || fallback;
  }

  // 1. APIException → { detail }
  if (typeof data.detail === "string") {
    return data.detail;
  }

  // 2a. ValidationError → { non_field_errors: [...] }
  const nonField = data.non_field_errors;
  if (Array.isArray(nonField) && nonField.length) {
    return String(nonField[0]);
  }

  // 2b. ValidationError → { <field>: ["mesaj"] } — ilk alanın ilk mesajı
  for (const value of Object.values(data)) {
    if (Array.isArray(value) && value.length) {
      return String(value[0]);
    }
    if (typeof value === "string" && value) {
      return value;
    }
  }

  return fallback;
}

/**
 * apiFieldErrors — DRF ValidationError'dan alan-bazlı hata haritası çıkarır
 * (form input'larına inline error bağlamak için). Örn:
 *   { starts_at: "Geçmiş bir tarih/saate rezervasyon oluşturulamaz." }
 */
export function apiFieldErrors(e: any): Record<string, string> {
  const data = e?.response?.data;
  const out: Record<string, string> = {};
  if (data == null || typeof data !== "object") return out;
  for (const [key, value] of Object.entries(data)) {
    if (key === "detail" || key === "non_field_errors") continue;
    if (Array.isArray(value) && value.length) {
      out[key] = String(value[0]);
    } else if (typeof value === "string" && value) {
      out[key] = value;
    }
  }
  return out;
}
